import { inject, injectable } from 'inversify';
import DITypes from '@creditflowresearch/json-rpc-dispatcher/dispatcher-cfr/DITypes';
import Request from '@framework/api/Rpc/Request';
import { RpcSuccess } from '@dealroadshow/json-rpc-dispatcher';
import { withServerCache } from '@/creditflowresearch/infrastructure/cache/withServerCache';
import type { IDispatcher } from '@creditflowresearch/json-rpc-dispatcher/dispatcher-cfr';

@injectable()
class MarketChartRepository {
  constructor(@inject(DITypes.JsonRpcDispatcher) protected readonly rpc: IDispatcher) {}

  @withServerCache({
    scope: 'MarketChart',
    ttlSeconds: 180,
    maxEntries: 25,
    anonymousOnly: true,
  })
  async getChartData(filters: {}) {
    const request = new Request('finsight_web.market.chart_data.get_chart_data', filters);
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult().payload;
  }
}

export default MarketChartRepository;
